import * as t from "io-ts";
import nullable from "./nullable";
export const RoleAdmin = "ORG_ADMIN";
const roleAdminT = t.literal(RoleAdmin);
const roleDispatcherT = t.literal("DISPATCHER");
export const userRoleT = t.union([roleAdminT, roleDispatcherT]);
export const meT = t.intersection([
    t.strict({
        id: t.string,
        first: t.string,
        role: nullable(userRoleT),
        driverLoginUrl: t.string,
        company_name: t.string,
        defaultPhoneCountryCode: t.string,
        teamIds: t.array(t.string),
        defaultTeamId: t.string,
        orgDefaultTeamId: nullable(t.string),
        features: t.record(t.string, t.boolean),
        searchOrigin: t.strict({
            lon: t.number,
            lat: t.number,
        }),
    }),
    t.exact(t.partial({ isSupportUser: t.literal(true) })),
]);
export const userT = t.strict({
    id: t.string,
    firstName: t.string,
    lastName: t.string,
    email: t.string,
    defaultTeamId: t.string,
    teamIds: t.array(t.string),
    role: nullable(userRoleT),
    disabledBy: nullable(t.string),
    disabledByExternal: t.boolean,
    invitationPending: t.boolean,
});
export const usersT = t.array(userT);
export const inviteUserInputT = t.strict({
    firstName: t.string,
    lastName: t.string,
    email: t.string,
    role: nullable(userRoleT),
});
export const inviteUserResultT = t.union([
    t.strict({ ok: t.literal(true), user: userT }),
    t.strict({
        ok: t.literal(false),
        error: t.union([
            t.literal("EMPTY_INPUT"),
            t.literal("INVALID_EMAIL"),
            t.literal("EMAIL_ALREADY_EXISTS"),
            t.literal("NO_DEFAULT_TEAM"),
        ]),
    }),
]);
//# sourceMappingURL=user.js.map